@if (!chatDismissed) {
<div class="chatbot-widget" [class.minimized]="chatMinimized">
  <div class="chatbot-header" (click)="toggleChat()">
    <div class="chatbot-header-left">
      <svg
        class="chatbot-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      >
        <path
          d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
        />
      </svg>
      <span class="chatbot-title">AI Assistant</span>
      <span class="chatbot-status">Online</span>
    </div>
    <div class="chatbot-header-actions">
    <button
      class="chatbot-toggle"
      (click)="toggleChat(); $event.stopPropagation()"
      aria-label="Toggle chat"
    >
      @if (!chatMinimized) {
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          width="16"
          height="16"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      }
      @if (chatMinimized) {
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          width="16"
          height="16"
        >
          <path d="M5 15l7-7 7 7" />
        </svg>
      }
    </button>
    <button
      type="button"
      class="chatbot-dismiss"
      (click)="dismissChat(); $event.stopPropagation()"
      aria-label="Dismiss chat"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        width="16"
        height="16"
      >
        <path d="M6 6l12 12M6 18L18 6" />
      </svg>
    </button>
    </div>
  </div>
  @if (!chatMinimized) {
    <div class="chatbot-body">
      <div class="chatbot-messages">
        @for (msg of chatMessages; track $index) {
          <div
            class="chat-message"
            [class.bot]="msg.from === 'bot'"
            [class.user]="msg.from === 'user'"
          >
            <div class="chat-bubble">{{ msg.text }}</div>
          </div>
        }
        @if (chatTyping) {
          <div class="chat-message bot typing">
            <div class="chat-bubble">
              <span class="typing-dots">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
        }
      </div>
      <form class="chatbot-input" (ngSubmit)="sendMessage()">
        <label for="ai-assistant-input" class="visually-hidden">Message</label>
        <input
          id="ai-assistant-input"
          type="text"
          [(ngModel)]="chatInput"
          name="chatInput"
          placeholder="Type a message..."
          class="chat-field"
          autocomplete="off"
        />
        <button type="submit" class="chat-send" [disabled]="!chatInput.trim()">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            width="18"
            height="18"
          >
            <path
              d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
            />
          </svg>
        </button>
      </form>
    </div>
  }
</div>
}
